<script>
export default {
beforeMount(){
        this.redirect();
    },
    methods: {
        redirect: function(e){
            let uri = window.location.href.split('?');
            let vars = uri[1].split('&');
            var code, message, msg;

            for (var key in vars) { 
                var kv = vars[key];
                var kvArr = kv.split('=');
                var k = kvArr[0];
                var v = kvArr[1];
                if(k == 'code'){
                    code = v;
                } else if(k == 'resultMessage'){
                    console.log('resultMessage ' + v)
                    if(v == 'userCancel'){
                        msg = '정기결제 등록을 취소하셨습니다. 주문 내용 확인 후 다시 등록해주세요.'
                    } else {
                        msg = decodeURIComponent(v);
                    }
                    
                } 
            }
            console.log(msg)
            if(!msg || msg == 'null'){
                msg = '결제 진행 중 승인에 실패하여 결제가 중단되었습니다. \n 관리자에게 문의하시려면 우측 하단 네이버톡톡 또는 채널톡을 이용해주세요.';
            } 

            swal(msg, {
                icon: "info"
            }).then(() => {
                this.$router.push('/main/pc4?tab=membership')
            });                      
        }
    

    }
}
</script>



// WEBPACK FOOTER //
// src/components/pay/NaverFail.vue